import api from './axiosInstance';

// When responseType=blob, the axios error path also wraps error bodies as
// a Blob — naive String(err.response.data) renders "[object Blob]". Read
// the blob, try to parse JSON or return raw text so callers see the real
// message from the backend (e.g., "CP58 template missing at ...").
async function readBlobError(err) {
  const blob = err?.response?.data;
  if (!(blob instanceof Blob)) {
    return err?.message || 'Download failed';
  }
  try {
    const text = await blob.text();
    if (!text) return `HTTP ${err.response?.status ?? '?'}`;
    try {
      const parsed = JSON.parse(text);
      return parsed.message || parsed.error || parsed.title || text;
    } catch {
      return text;
    }
  } catch {
    return err?.message || 'Download failed';
  }
}

async function downloadOrThrow(promise, filename) {
  try {
    const res = await promise;
    triggerDownload(res.data, filename);
  } catch (err) {
    const msg = await readBlobError(err);
    const wrapped = new Error(msg);
    wrapped.original = err;
    throw wrapped;
  }
}

// Self-service: returns own CP58 PDF for the chosen calendar year.
export const downloadMyCp58 = (year) =>
  downloadOrThrow(
    api.get('/Cp58/my', { params: { year }, responseType: 'blob' }),
    `CP58_${year}_mine.pdf`,
  );

// Accountant single-agent fetch (requires Cp58Generator right).
export const downloadAgentCp58 = (userId, year) =>
  downloadOrThrow(
    api.get(`/Cp58/agent/${userId}`, { params: { year }, responseType: 'blob' }),
    `CP58_${year}_${userId}.pdf`,
  );

// Accountant bulk export (zip of PDFs, requires Cp58Generator right).
export const downloadBulkCp58 = (year, nonZeroOnly = true) =>
  downloadOrThrow(
    api.post('/Cp58/bulk', null, { params: { year, nonZeroOnly }, responseType: 'blob' }),
    `CP58_${year}_bulk.zip`,
  );

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
